<template>
  <div class="articles-DefaultLayout main-con">
    <div class="text-black bg-black py-4 px-4 px-md-0 position-relative z-100">
      <div class="pa-4 mb-12">
        <div class="container mx-auto pa-4 d-flex flex-colum ga-16 item-content">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { onMounted } from 'vue';
  onMounted(() => {});
</script>

<style scoped></style>
